import * as React from "react"

//import Layout from "../components/layout"
import Hero from "../components/hero"
import Layout from "../components/layout"
import SearchEngine from "../components/searchEngine"
import Seo from "../components/seo"

const IndexPage = () => (
  <Layout>
    <Seo title="Economics of Creative Destruction" />
    <Hero />
    <SearchEngine />
  </Layout>
)

export default IndexPage
